import React from 'react';
import { Emoji } from 'emoji-mart';
import styled from 'styled-components';

const legacyStampMapper = {
  green: 'green_apple',
  yellow: 'full_moon',
  orange: 'large_orange_diamond',
  red: 'red_circle',
  purple: 'aquarius',
  blue: 'large_blue_circle',
  pink: 'ribbon',
};

const SelectedContainer = styled.div`
  width: ${({ size }) => (size ? `${size + 3.5}px` : '20px')};
  height: ${({ size }) => (size ? `${size + 3.5}px` : '20px')};
  border-radius: 50%;
  background-color: ${({ theme, selected }) => (selected ? theme.primaryColour : null)};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ canClick }) => (canClick ? 'pointer' : 'default')};
  button, span {
    ${({ canClick }) => (canClick ? 'pointer' : 'default')};
  }
  ${({ canClick }) => canClick && `
    span {
      &:hover {
        opacity: 75%;
      }
    }
  `}

  > span {
    display: flex !important;
  }
`;

function EmojiComponent({
  selected, emoji, onClick, ...rest
}) {
  if (emoji?.id in legacyStampMapper) emoji.id = legacyStampMapper[emoji.id];
  return (
    <SelectedContainer selected={selected} canClick={!!onClick} onClick={onClick ? () => onClick(emoji) : null} {...rest}>
      <Emoji emoji={emoji} style={{ display: 'flex' }} {...rest} />
    </SelectedContainer>
  );
}

export default EmojiComponent;
